import { parseISO, startOfDay } from "date-fns"

export function dateStringToDate(dateString: string, includeTime = false): Date {
  const dateTime = parseISO(dateString)
  if (includeTime) return dateTime
  return startOfDay(dateTime)
}
